// This serves at https://swiftleaddigital.com/pri

const PrivacyPolicy = () => {

    return (
        <>

            <div className="p-8 bg-[#212A37] text-[#FFFFFC] min-h-screen flex flex-col">

                {/* Header Section */}
                <header className=" fixed top-0 left-0 right-0 w-full p-4 flex justify-between items-center border-b border-[#FFFFFC] bg-[#212A37]/80 backdrop-blur">

                </header>
                {/* Main Content Section */}
                <main>
                    <div className="flex-grow flex mt-12 justify-center">
                        <div className="bg-[#212A37] p-8 max-w-lg w-full">
                            <h1 className="text-3xl font-bold mt-6 mb-6">Privacy Policy</h1>

                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default PrivacyPolicy;
